import { TIBBO_DEVICE_ID } from '@appblocks/platforms/PlatformUtils';
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    BlockType,
    CodeBlock,
    Define,
    SettingType,
    TimeFormats,
} from '@appblocks/codegeneration/types';
import * as tios from './tios';
import * as simulator from './simulator';

export default class Cron extends BaseFeature {
    constructor() {
        super();
        this.id = 'cron';
        this.name = 'Scheduler';
        this.icon = 'IoCalendarOutline';
        this.requirements = ['rtc', 'tios'];

        this.settings = this.settings.concat([
            {
                id: 'SCHEDULES',
                name: 'Schedules',
                settingType: SettingType.ARRAY,
                refId: 'crontab',
                default: new Array<BaseFeature>(0),
                helpText: 'Schedules are used in blocks to run functions on predefined intervals.',
            },
        ]);
    }

    getDependencies() {
        if (this.getSettingValue('SCHEDULES').length > 0) {
            return [
                'datetime',
                'sntp',
            ];
        }
        return [];
    }

    getEnabled(): boolean {
        const SCHEDULES = this.getSettingValue('SCHEDULES');
        return SCHEDULES.length > 0;
    }

    getDefines(): Array<Define> {
        const SCHEDULES = this.getSettingValue('SCHEDULES');
        return [
            {
                name: 'CRON_MAX_SCHEDULES',
                value: SCHEDULES.length,
            },
        ];
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'tios':
                return tios.getCodeBlocks(this);
            case 'simulator':
                return simulator.getCodeBlocks(this);
            default:
                return [];
        }
    }

    getDetails(): string {
        return `
## Scheduler
Schedules can be used to run functions on predefined intervals. 

The **On Scheduled Event** block can be used to trigger functions when a scheduled time has been reached.

![scheduler blocks](/static/img/blocks_scheduler.png)

        `;
    }

    getDocURL(): string {
        return `${process.env.HOME_URL}/docs/features/scheduler`;
    }
}
